import { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { getStripeSession } from '../ctapi/stripe'; 

const determineTierFromAmount = (amount) => {
  switch (amount) {
    case 2499: 
      return 'basic';
    case 4999: 
      return 'pro';
    // Add other pricing tiers here
    default:
      return null;
  }
};

export const useStripeSession = () => {
  const [searchParams] = useSearchParams();
  const [sessionData, setSessionData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  const sessionId = searchParams.get("session_id");
  const qsEmail = searchParams.get("email") ?? "";
  const qsSubscriptionTier = searchParams.get("subscriptionTier") ?? null;
  const qsSubscriptionStatus = searchParams.get("subscriptionStatus") ?? null;

  useEffect(() => {
    const fetchSession = async () => {
      if (!sessionId) {
        setIsLoading(false);
        return;
      }
      
      setIsLoading(true);
      setError(null);
      try {
        const data = await getStripeSession(sessionId);
        if (data) {
          setSessionData(data);
        } else {
          throw new Error("Could not verify your subscription session. Please try again or contact support.");
        }
      } catch (e) {
        setError(e.message);
      } finally {
        setIsLoading(false);
      }
    };

    fetchSession();
  }, [sessionId]);

  const email = sessionData?.customer?.email ?? qsEmail;
  const derivedTier = determineTierFromAmount(sessionData?.session?.amount_total);
  const tier = sessionData?.subscriptionTier ?? derivedTier ?? qsSubscriptionTier;
  const status = sessionData?.session?.status ?? qsSubscriptionStatus;
  console.log("[useStripeSession] Returning final values:", { isLoading, email, tier, status, sessionId, error });

  return { isLoading, sessionData, email, tier, status, sessionId, error };
};